<template>
  <div class="color-sample-shades mb-5">
      <div class="baumitlife-shades row pt-5">
        <div class="col-12">
          <h2 class="mb-5 mt-5">{{ trans('sample_order_color_shades') }}</h2>
          <div class="row px-1">
            <div class="col" v-for="(color,index) in shades" :key="'shade_'+index">
                  <div  class="card-item color-card-item color-card-item-small" :data-card-id="color.card.id">
                    <div class="inner" >
                      <div class="color-card-color-background" :style="{ background : (color.hex && color.hex.length>0) ? (color.hex.substring(0,1) != '#' ? '#' : '')+color.hex : 'url('+color.image+')' }">
                      </div>
                      <div class="color-card-detail">
                        <div class="inline-extra-icon">
                          <div class="extra" >
                            <i class="actionToggleDashboard material-icons " :data-card-id="color.card.id" data-add-url="/myBaumit/ajaxAddCardToDashboard" data-delete-url="/myBaumit/ajaxDeleteCardFromDashboard" data-added-to-dashboard="0">star_border</i>
                            <a class="addtoCartButton" v-if="color.isAvailableInSampleOrder" href="javascript:;" @click="addToCart(color.id )"><i class="fa fa-cart-plus mr-2"></i> <span v-if="false">{{ trans('sample_order_addtocart_button') }}</span></a>
                          </div>
                        </div>
                        {{ trans('products_color_code') }}
                        <div class="color-card-title">
                          {{ color.name }}
                        </div>
                        <template v-if="color.hex && color.hex.length>0">
                          HEX: #{{ color.hex }}<br>
                        </template>
                        <template v-if="color.rgb_r && color.rgb_r.length>0">
                          RGB: {{ color.rgb_r+'/'+color.rgb_g+'/'.color.rgb_b }}<br>
                        </template>
                        <!-- <template v-if="color.tsr && color.tsr > 25">
                          TSR: > 25 <br>
                        </template>
                        <template v-if="color.tsr && color.tsr <= 25">
                          TSR: ≤ 25<br>
                        </template>  -->
                        <template v-if="color.hbw">
                          HBW: {{ color.hbw }}<br>
                        </template>
                      </div>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {translate} from "../service/translation";
import axios from 'axios';
export default {
  components: {
    
  },
  props : {
    shades : {
      required : true,
      type: Array
    },
    
  },
  methods : {
    trans(key){
      return translate(key);
    },
    addToCart(color_id){
      let self = this;
      axios.post('/sample-order/cart', {
        action : 'add',
        item_id : color_id,
      })
      .then(function(response) {
        if (response.data.success) {
          window.$("html, body").stop().animate({scrollTop: window.$('.sample-order-app-container').eq(0).offset().top}, 500, 'swing');
          self.$emit('updateCartData', response.data.cartData);
        }
      });
    }
  },
}
</script>

<style>
  .color-sample-shades {
    width:100%;
  }
  .color-sample-shades .card-item.color-card-item .inner .color-card-detail .inline-extra-icon{
    width:100%;
  }
  .color-sample-shades .color-card-detail .inline-extra-icon .addtoCartButton i{
    line-height:1;
    font-size:24px;
    position:relative;
    top:-3px;
    color:#e2001a;
  }
</style>
